import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { formatNumber } from "src/utility";

type Props = {
  items: DiscountItemType[];
  selectedItemIndex: number;
  onSelect: (i: number) => void;
};

const GiftcardChips: FC<Props> = ({ items, selectedItemIndex, onSelect }) => {
  const { t } = useTranslation();

  if (items.length <= 1) return null;

  return (
    <div className="flex flex-col gap-4">
      <span className="text-sm font-medium text-font-default">{t("Giftcards.selectValue")}</span>
      <div className="flex flex-wrap gap-2">
        {items.map((item, i) => (
          <button
            key={item.code}
            type="button"
            onClick={() => onSelect(i)}
            className={`flex min-w-24 flex-1 cursor-pointer items-baseline justify-center gap-1 rounded-sm px-4 py-3 text-base font-medium transition-colors ${
              i === selectedItemIndex
                ? "bg-background-primary text-font-inverted"
                : "bg-background-default text-font-default outline outline-border-subtle hover:outline-border-active hover:text-font-active"
            }`}
          >
            {formatNumber(item.totalPrice)}
            <span className="text-xs">{item.currency ?? t("Giftcards.currencyFallback")}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default GiftcardChips;
